import {useNavigate} from "react-router-dom";
import React, {useEffect, useState} from 'react';
import './Login.css'
import {FormControl, Grid} from "@mui/material";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {RouteInfo} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import CopyRightLinkRaiko from "../../raikoComponents/copyRightLinkRaiko/CopyRightLinkRaiko";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import RaikoMaterialOutlinedPasswordInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedPasswordInput";
import AppBrand from "../../component/appBrand/AppBrand";
import DarkModeToggle from "../../component/darkModeToggle/DarkModeToggle";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {LoginService} from "./LoginService";
import {getAdminRoles} from "../../service/authService/AuthService";
import {useAuthState} from "../../context/AuthContext";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";


const Login = () => {

    const snackbarState = useSnackbarDispatcher()

    const {loginState} = useAuthState()

    const loading = useLoadingDispatcher()

    const service = new LoginService()

    const navigate = useNavigate()

    useEffect(() => {
        if (typeof loginState !== "undefined" && loginState) {
            const roles = getAdminRoles()

            for (const role in roles) {
                if (RouteInfo.Dashboard.accessRole.includes(role)) {
                    navigate(RouteInfo.Dashboard.globalUrl)
                    return
                }
            }

            navigate(RouteInfo.Profile.url)
        }
    }, [loginState])

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState("");

    function doUserLogin() {

        loading(setLoadingStateDispatch(true))
        if (username.length > 0 && password.length > 0) {

            service.sendVerificationCode(username, password)
                .then(response => {

                    if (response.data.status === "SENT") {
                        goToConfirmCodePage()
                        snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_INFO, "کد تایید با موفقیت ارسال شد."))
                        loading(setLoadingStateDispatch(false))
                    } else {
                        loading(setLoadingStateDispatch(false))
                        snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا، امکان ارسال پیامک در این لحظه وجود ندارد!"))
                    }

                }).catch(reason => {
                loading(setLoadingStateDispatch(false))
                snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, new ServerErrorHandler(reason).getMessage()))
            })
        } else {
            snackbarState(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری و رمز عبور را به درستی وارد نمایید!"))
            loading(setLoadingStateDispatch(false))
        }
    }

    function goToConfirmCodePage() {
        navigate(
            RouteInfo.ConfirmPhoneNumber.globalUrl, {
                state: {
                    username: username,
                    login: true
                }
            })
    }

    return (
        <>
            <Grid xs={12} id="login-container">
                <section className="loginCardContainer default-card-container-background-style">
                    <div className="loginCardBody">
                        <AppBrand/>

                        <span className={css`
                            font-size: 16px;
                            margin-bottom: .5rem;
                            width: 100%;
                            text-align: center;
                            transition: var(--base-transition);
                            color: var(--color-text);
                        `}>
                            خبرگزاری آوای پرران
                        </span>
                        <span className={css`
                            font-size: 14px;
                            margin-bottom: 1.5rem;
                            width: 100%;
                            text-align: center;
                            transition: var(--base-transition);
                            color: var(--color-text);
                        `}>
                        برای ورود نام کاربری و رمز عبور خود را وارد نمایید.
                    </span>

                        <RaikoMaterialOutlinedInput
                            labelText="نام کاربری"
                            placeHolder="نام کاربری خود را وارد نمایید"
                            spellCheck="false"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            className={css`margin-bottom: .5rem !important`}
                        />

                        <FormControl fullWidth>
                            <RaikoMaterialOutlinedPasswordInput
                                labelText="رمز عبور"
                                placeHolder="رمز عبور خود را وارد کنید"
                                spellCheck={false}
                                value={password}
                                onChange={e => setPassword(e.target.value)}

                                onKeyUp={e => {

                                    if (e.key === 'Enter') {
                                        doUserLogin()
                                    }
                                }}

                            />
                        </FormControl>
                        <ButtonPrimaryRaiko
                            className={css`
                                width: 100%;
                                margin-top: 1rem !important;
                                margin-bottom: 1rem !important;
                            `}

                            onClick={() => {
                                doUserLogin()
                            }}
                            label="ورود"
                        />

                        {/*<NavLink
                            className={css`
                              font-size: var(--text-size-min);
                              margin-bottom: 1.5rem;

                              &:hover span {
                                color: var(--color-text) !important;
                              }
                            `}
                            to={RouteInfo.ForgetPassword.globalUrl}
                        >
                            <div className={css`
                              display: flex;
                              flex-direction: row;
                              flex-wrap: nowrap;
                              gap: .25rem;
                            `}>
                            <span className={css`color: var(--color-text);
                              transition: all 150ms ease-in;`}>رمز عبور خود را فراموش کرده اید؟</span>
                                <span className={css`color: var(--color-variant);
                                  transition: all 150ms ease-in;`}>بازیابی رمز عبور</span>
                            </div>
                        </NavLink>*/}

                        <CopyRightLinkRaiko/>
                    </div>
                </section>

                <div className={css`display: flex;
                    align-items: start;
                    margin-top: 1rem;
                `}>
                    <DarkModeToggle/>
                </div>
            </Grid>
        </>
    )
};

export default Login;

